export default __webpack_public_path__ + "static/media/404.63d3a905.svg";